import { render, staticRenderFns } from "./kpisetting.vue?vue&type=template&id=2af25d50&lang=pug&"
import script from "./kpisetting.vue?vue&type=script&lang=js&"
export * from "./kpisetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports